// extracted by mini-css-extract-plugin
module.exports = {"label_spec":"woundReport_label_spec__mNvlg","wound_dashboard":"woundReport_wound_dashboard__18gZX"};